import AbstractMathFormulaVisitor from "./AbstractMathFormulaVisitor.js";

/**
 * `LatexFormulaVisitor` is a formula visitor used to produce a math
 * formula LaTeX string. This LaTeX string is used by FormulaWidget to
 * render it in the DOM with MathJax.
 */
export default class LatexFormulaVisitor extends AbstractMathFormulaVisitor {
	formula(node) {
		return `\\[${this.visit(node)}\\]`;
	}

	visitDivisionNode(node) {
		// We don't care about the parentheses added in superclass
		// because we use \frac{}{} which already groups operands
		// correctly
		return this._divide({
			dividend: this.visit(node.getLeftOperand()),
			divisor: this.visit(node.getRightOperand()),
		});
	}

	_add({ leftOperand, rightOperand }) {
		return `${leftOperand} + ${rightOperand}`;
	}

	_subtract({ leftOperand, rightOperand }) {
		return `${leftOperand} - ${rightOperand}`;
	}

	_multiply({ multiplicand, multiplier }) {
		return `${multiplicand} \\times ${multiplier}`;
	}

	_divide({ dividend, divisor }) {
		return `\\frac{${dividend}}{${divisor}}`;
	}

	_negated({ expression }) {
		return `-${expression}`;
	}

	_text(text) {
		return `\\text{${text}}`;
	}

	_link({ href, text }) {
		return `\\href{${href}}{${text}}`;
	}

	_or({ leftOperand, rightOperand }) {
		return `${leftOperand} \\mid ${rightOperand}`;
	}

	_wrapInParenthesis(expression) {
		return `(${expression})`;
	}

	_textWithOptions({ text, options }) {
		return `${this._text(text)}(${options
			.map((each) => `${each}`)
			.join(", ")})`;
	}
}
